import { isEmpty, type Optional } from '@festina-life/core'
import { useTranslateEnum } from '@festina-life/ui/hooks'
import { useCallback } from 'react'

/**
 * Temporary added until LIFE-10996 gets resolved
 */
export const stripMigrationFromName = (name: string) => {
  if (name.startsWith('mig.')) {
    return name.slice('mig.'.length)
  } else {
    return name
  }
}

export const useTranslatePolicy = () => {
  const translateEnum = useTranslateEnum()

  return useCallback(
    (policyKey: Optional<string>) => {
      if (isEmpty(policyKey)) {
        return '-'
      }

      const [templateIdentifier, policyNumber] =
        stripMigrationFromName(policyKey).split('#')

      const translatedPolicy = translateEnum(
        'enum.PolicyType',
        templateIdentifier,
      )

      return isEmpty(policyNumber)
        ? translatedPolicy
        : `${translatedPolicy} #${policyNumber}`
    },
    [translateEnum],
  )
}
